import React, { useState } from 'react'
import './index.css'
import { Button, Input, Select, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/date-picker/locale/zh_CN'; // 引入中文包
import moment from 'moment';
export default function Serach(props) {
    const { RangePicker } = DatePicker;
    const { fields, initState, onSearch } = props;
    const [state, setState] = useState(initState);
    //输入框赋值
    const inputChange = (event) => {
        if (!event.target.value) {
            setState({
                ...state,
                [event.target.name]: ''
            })
        } else {
            setState({
                ...state,
                [event.target.name]: event.target.value
            })
        }
    }
    const handleSearch = () => {
        if (onSearch) {
            onSearch(state);
        }
    };

    const handleChange = (selectName, value) => {
        setState({
            ...state,
            [selectName]: value
        })
    };


    const handTimeChange = (name, _, dateStrings) => {
        setState({
            ...state,
            [name]: dateStrings
        })
      };
    return (
        <React.Fragment>
            <div className="search-main-div">
                <div className="search-items">
                    {
                        fields.map((item, index) => {
                            const fieldName = item.fieldName
                            const fieldType = item.fieldType
                            const optionData = item.optionData
                            let text="";
                            switch (fieldType) {
                                case "select":
                                    text = <Select
                                        className="search-input-style"
                                        placeholder={item.placeholder}
                                        onChange={(value) => handleChange(fieldName, value)}
                                        options={optionData}
                                    />
                                    break;
                                case "time":
                                    text = <RangePicker className="search-input-style"  name={fieldName} showTime locale={zhCN} format="YYYY-MM-DD HH:mm" onChange={(dates,dateStrings) => handTimeChange(fieldName,dates,dateStrings)}/>
                                    break;
                                default:
                                    text = <div className="search-input-style" >
                                        <Input placeholder={item.placeholder} name={fieldName} value={state.fieldName} onChange={inputChange} />
                                    </div>
                                    break;
                            }
                            return <div key={index} className="search-field-div">
                                <div className="search-field-style"><span>{item.fieldCnName}</span></div>
                                {text}

                            </div>
                        })
                    }
                </div>
                <div className="search-bt-div">
                    <Button onClick={handleSearch} style={{ width: '100px', marginRight: '10px', backgroundColor: '#68cf4f' }} block  ><SearchOutlined />查询</Button>
                    {/* <Button style={{ width: '100px', marginRight: '10px', backgroundColor: '#e5e541' }} block  ><PlusOutlined />新增</Button>
                    <Button style={{ width: '100px', marginRight: '10px', backgroundColor: '#ec7d6f' }} block  ><DeleteOutlined />批量删除</Button> */}
                </div>

            </div>
        </React.Fragment>
    )
}
